// hookes
import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { Round, RoundSummary } from '@/vue3/api/models';

export const useRoundService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getAllRoundSummaries = async (
        courseSchemaId: number,
    ): Promise<RoundSummary[]> => {
        const res = await axios.get(
            `${apiUrl}/round/summary/course-schema/${courseSchemaId}`,
        );
        return res.data;
    };

    const getAllRound = async (): Promise<Round[]> => {
        const res = await axios.get(`${apiUrl}/round`);
        return res.data;
    };

    const getRound = async (id: number): Promise<Round> => {
        const res = await axios.get(`${apiUrl}/round/${id}`);
        return res.data;
    };

    const createRound = async (round: Round): Promise<Round> => {
        const res = await axios.post(`${apiUrl}/round`, round);
        return res.data;
    };

    const updateRound = async (round: Round): Promise<Round> => {
        const res = await axios.put(`${apiUrl}/round`, round);
        return res.data;
    };

    const deleteRound = async (id: number): Promise<Round> => {
        const res = await axios.deleteId(`${apiUrl}/round/${id}`);
        return res.data;
    };

    //---------------Round PDF Template------------------------------------------------

    const getRoundPDFTemplate = async (roundId: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/round-pdf-template/${roundId}`);
        return res.data;
    };
    const createRoundPDFTemplate = async (
        roundTemplateData: any,
    ): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/round-pdf-template`,
            roundTemplateData,
        );
        return res.data;
    };
    const updateRoundPDFTemplate = async (
        roundTemplateData: any,
    ): Promise<any> => {
        const res = await axios.put(
            `${apiUrl}/round-pdf-template`,
            roundTemplateData,
        );
        return res.data;
    };
    const deleteRoundPDFTemplate = async (roundId: number): Promise<any> => {
        const res = await axios.deleteId(
            `${apiUrl}/round-pdf-template/${roundId}`,
        );
        return res.data;
    };

    return {
        getAllRoundSummaries,
        getAllRound,
        getRound,
        createRound,
        updateRound,
        deleteRound,
        getRoundPDFTemplate,
        createRoundPDFTemplate,
        updateRoundPDFTemplate,
        deleteRoundPDFTemplate,
    };
};
